import { browserHistory } from 'react-router';
import Flux from 'flux';
import AppConstants from 'constants/AppConstants';

import LocationsCollection from 'collections/LocationsCollection';
import DepartmentsCollection from 'collections/DepartmentsCollection';
import LoginCollection from 'collections/LoginCollection';
import OffersCollection from 'collections/OffersCollection';
import ShiftCollection from 'collections/ShiftCollection';
import UnavailableTypesCollection from 'collections/UnavailableTypesCollection';
import UnavailablesCollection from 'collections/UnavailablesCollection';
import AvailablesCollection from 'collections/AvailablesCollection';
import UserSettingCollection from 'collections/UserSettingsCollection';
import AccountCollection from 'collections/AccountCollection';
import TimeSheetCollection from 'collections/TimeSheetCollection';
import UserCollection from 'collections/UserCollection';
import BidsCollection from 'collections/BidsCollection';
import ExchangesCollection from 'collections/ExchangesCollection';
import NotificationsCollection from 'collections/NotificationsCollection';
import WorkspaceCollection from 'collections/WorkspaceCollection';
import Utils from 'Utils';

window.MakeShiftEmployeeDispatcher = new Flux.Dispatcher();
window.$ = $;

window.Utils = new Utils();
window.Utils.lastContaierHeight = 0;
window.Utils.setBrowserHistory(browserHistory);

// Collections
window.LoginStore = new LoginCollection();
window.AccountStore = new AccountCollection();
window.UserStore = new UserCollection();
window.OffersStore = new OffersCollection();
window.ShiftStore = new ShiftCollection();
window.ExchangesStore = new ExchangesCollection();
window.BidsStore = new BidsCollection();
window.NotificationsStore = new NotificationsCollection();
window.AvailabilitiesStore = new AvailablesCollection();
window.UnavailablesStore = new UnavailablesCollection();
window.UnavailableTypesStore = new UnavailableTypesCollection();
window.UserSettingsStore = new UserSettingCollection();
window.DepartmentsStore = new DepartmentsCollection();
window.LocationStore = new LocationsCollection();
window.TimeSheetStore = new TimeSheetCollection();
window.WorkspaceStore = new WorkspaceCollection();
window.appConstants = AppConstants;

window.moment = require('moment');
window.momentTimezone = require('moment-timezone');
window.momentRange = require('moment-range');

window.momentRange.extendMoment(window.moment);
window.Popover = require('components/popover/Popover.js').default;
window.Pikaday = require('pikaday');
